<template>
  <div>
    <b-row>
      <b-colxx xxs="12">
        <b-row align-v="center" align-h="center" class="mt-2" no-gutters>
          <b-col>
            <b-form-group label="이미지 제목">
              <b-input-group size="sm">
                <b-form-input type="text" v-model="data.title"/>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row align-v="center" align-h="center" class="mt-1" no-gutters>
          <b-col>
            <b-form-group label="이미지 설명">
              <quill-editor class="bubble"
                            ref="myTextEditorBubble"
                            v-model="data.description"
                            :options="editorOptionBubble"
                            @change="onEditorChange($event)">
              </quill-editor>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row align-v="center" align-h="center" class="mt-1" no-gutters>
          <b-col>
            <b-form-group label="이미지(최대 10개)">
              <sortable-file-uploader :compact="false" :max-files="10"
                                      @getFileData="subImageHanddling"></sortable-file-uploader>
            </b-form-group>
          </b-col>
        </b-row>

      </b-colxx>
    </b-row>
  </div>
</template>

<script>
  import 'vue-select/dist/vue-select.css'
  import SortableFileUploader from "../../../../components/Upload/SortableFileUploader.vue";

  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'
  import {quillEditor} from 'vue-quill-editor'

  export default {
    components: {
      'sortable-file-uploader': SortableFileUploader,
      'quill-editor': quillEditor
    },
    props: ['data'],
    data() {
      return {
        content: '',
        contentBubble: '',
        editorOptionBubble: {
          theme: 'bubble',
          placeholder: '',
          modules: {
            toolbar: [
              [
                'bold',
                'italic',
                'link',
                {header: 1},
                {header: 2},
                'blockquote'
              ]
            ]
          }
        },
      }
    },
    methods: {
      onEditorChange({editor, html, text}) {
        this.description = html
      },
      subImageHanddling(file) {
        // if (file.length > 0 ) {
        //   file.forEach(function(value , index ){
        //     let reader = new FileReader()
        //     reader.readAsDataURL(value.file)
        //     reader.onload = evt => {
        //       let image = new Image();
        //       image.onload = () => {
        //
        //         this.subImageFile.push({
        //           index : index ,
        //           width: image.width,
        //           height: image.width,
        //           size: (Math.round(value.file.size / 1024)).toString() + 'KB',
        //           _src: evt.target.result
        //         })
        //       }
        //       image.src = evt.target.result
        //     }
        //   })
        // } else {
        //   this.subImageFile = []
        // }

      }
    } , watch :{
      subImageFile(){
        // console.log(this.subImageFile)
      }
    }
  }
</script>
